import BASE_RULE from '../baseRule';
import {SearchTypeCart} from './constants';
import {CartRule} from './types';

export const cartRuleDefaults: CartRule = {
	...BASE_RULE,
	elementType: SearchTypeCart,
	elementSubType1: 0,
	elementSubType2: 0,
	/**
	 * @default current cart
	 */
	elementValue1: 0,
};

export default cartRuleDefaults;
